PJQ.modules = {};

$(function () {
	PJQ.app.beforeReady();
});